import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PayRocPage } from './payroc.page';

const routes: Routes = [
  {
    path: '',
    component: PayRocPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PayRocPageRoutingModule {}
